type Props = {
  displayName: string;
};

export function AIChatWelcome({ displayName }: Props) {
  const first = displayName?.trim() || "there";

  return (
    <div className="px-6 text-center">
      <h1 className="text-3xl font-bold tracking-tight text-[#111827] md:text-4xl">
        Welcome, {first}
      </h1>
      <p className="mt-3 max-w-xl text-sm leading-6 text-[#6B7280] md:text-base">
        Ask me anything about your patients, caretakers, or programs. I can help
        summarize data, find records, or analyze trends.
      </p>
    </div>
  );
}
